import { BaseInputProps, InputChangeEvent } from '@utils/types/baseComponents';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { ArrowButton } from '@assets/icons';
import { colors } from '@utils/constants/colors';
import styles from './styles.module.scss';

type Props = {
  onSubmit: (value: string) => void;
  defaultValue?: string;
} & BaseInputProps;

export function SearchField(props: Props) {
  const { onSubmit, containerStyle, defaultValue } = props;
  const [value, setValue] = useState(defaultValue || '');

  useEffect(() => {
    if (defaultValue !== value) {
      setValue(defaultValue || '');
    }
  }, [defaultValue]);

  const onInputChange = (e: InputChangeEvent) => {
    setValue(e.target.value);
  };

  return (
    <div className={clsx([styles.searchWrapper, containerStyle])}>
      <input
        value={value}
        name="search-input"
        type="text"
        placeholder="Search"
        onChange={onInputChange}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            onSubmit(value);
            e.currentTarget.blur();
          }
        }}
      />

      <ArrowButton
        className={styles.searchWrapper__arrowButton}
        onClick={() => onSubmit(value)}
        bgFill={colors.roveDarkerTan}
        arrowFill={colors.roveOffWhite}
      />
    </div>
  );
}
